import { AdminTreeProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import ForestryIcon from "@ecologi/assets/icons/ProjectInsights/forestry.svg";

export const reforestationVisuals: Record<
  AdminTreeProjectType,
  ProjectVisualsType
> = {
  REFORESTATION: {
    icon: <ForestryIcon />,
    pictogram: `/images/app/forest/carbon_avoidance/pictograms/forestry.svg`,
  },
};
